import type { RouteObject } from "react-router-dom";

export const developerPlatformAdoptionRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Developer platform adoption" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { DeveloperPlatformAdoptionPage } =
            await import("./developer-platform-adoption-page");
          return { Component: DeveloperPlatformAdoptionPage };
        },
      },
    ],
  },
];
